webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("cbRa");
module.exports = __webpack_require__("HRs4");


/***/ }),

/***/ "6KHs":
/***/ (function(module, exports) {

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = function () {
  return window.requestAnimationFrame || function ( /* function */callback, /* DOMElement */element) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

/***/ }),

/***/ "6N6B":
/***/ (function(module, exports) {

/*
 *	@created: 14.01.2016, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 *
 */

(function( $ ) {
	var iWindowWidth = $(window).width();
	var iWindowHeight = $(window).height();

	$(window).resize(function(){
		iWindowWidth = $(window).width();
		iWindowHeight = $(window).height();
	});

	$(document).ready(function(){
		// js is enabled
		$('body').removeClass('t3z-nojs');

		/* Button toTop: scroll to the top of the page  */
		$('#totop, .t3z-ce-totop a').click(function(event){
			event.preventDefault();
			var sTarget = 'body';
			scroll2(sTarget, 0);
		});


		/* Menu offcanvas */
		// mobil navigation: add arrows for submenus
		$( "#t3z-mainmenu ul li.sub" ).append( "<span class='mobile-only'></span>" );

		// mobil navigation: open sub level
		$('#t3z-mainmenu ul li.sub > span').click(function(event){
			$(this).parent().toggleClass( "open" );
			$(this).parent().find( "> ul" ).slideToggle( "slow");
		});

		$('#t3z-main-menu-toogle-close').click(function(event){
			$('#t3z-mainmenu ul').find( "li.open > ul" ).slideToggle( "slow");
			$('#t3z-mainmenu ul li.open').removeClass( "open" );

		});



		function scroll2(oElement, iOffset) {
			$('html, body').animate({ scrollTop: ($(oElement).offset().top) + iOffset}, 'slow');
		};

	});

})( jQuery );

/***/ }),

/***/ "DyA4":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * author Christopher Blum
 *    - based on the idea of Remy Sharp, http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 *    - forked from http://github.com/zuk/jquery.inview/
 */
(function (factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    // Node, CommonJS
    module.exports = factory($);
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {

  var inviewObjects = [],
      viewportSize,
      viewportOffset,
      d = document,
      w = window,
      documentElement = d.documentElement,
      timer;

  $.event.special.inview = {
    add: function add(data) {
      inviewObjects.push({ data: data, $element: $(this), element: this });
      // Use setInterval in order to also make sure this captures elements within
      // "overflow:scroll" elements or elements that appeared in the dom tree due to
      // dom manipulation and reflow
      // old: $(window).scroll(checkInView);
      //
      // By the way, iOS (iPad, iPhone, ...) seems to not execute, or at least delays
      // intervals while the user scrolls. Therefore the inview event might fire a bit late there
      //
      // Don't waste cycles with an interval until we get at least one element that
      // has bound to the inview event.

      if (!timer && inviewObjects.length) {
        timer = requestInterval(checkInView, 250);
      }
    },

    remove: function remove(data) {
      for (var i = 0; i < inviewObjects.length; i++) {
        var inviewObject = inviewObjects[i];
        if (inviewObject.element === this && inviewObject.data.guid === data.guid) {
          inviewObjects.splice(i, 1);
          break;
        }
      }

      // Clear interval when we no longer have any elements listening
      if (!inviewObjects.length) {
        clearRequestInterval(timer);
        timer = null;
      }
    }
  };

  function getViewportSize() {
    var mode,
        domObject,
        size = { height: w.innerHeight, width: w.innerWidth };

    // if this is correct then return it. iPad has compat Mode, so will
    // go into check clientHeight/clientWidth (which has the wrong value).
    if (!size.height) {
      mode = d.compatMode;
      if (mode || !$.support.boxModel) {
        // IE, Gecko
        domObject = mode === 'CSS1Compat' ? documentElement : // Standards
        d.body; // Quirks
        size = {
          height: domObject.clientHeight,
          width: domObject.clientWidth
        };
      }
    }

    return size;
  }

  function getViewportOffset() {
    return {
      top: w.pageYOffset || documentElement.scrollTop || d.body.scrollTop,
      left: w.pageXOffset || documentElement.scrollLeft || d.body.scrollLeft
    };
  }

  function checkInView() {
    if (!inviewObjects.length) {
      return;
    }

    var i = 0,
        $elements = $.map(inviewObjects, function (inviewObject) {
      var selector = inviewObject.data.selector,
          $element = inviewObject.$element;
      return selector ? $element.find(selector) : $element;
    });

    viewportSize = viewportSize || getViewportSize();
    viewportOffset = viewportOffset || getViewportOffset();

    // Show images 200 px below the fold
    //viewportOffset.top += 200;

    for (; i < inviewObjects.length; i++) {
      // Ignore elements that are not in the DOM tree
      if (!$.contains(documentElement, $elements[i][0])) {
        continue;
      }

      var $element = $($elements[i]),
          elementSize = { height: $element[0].offsetHeight, width: $element[0].offsetWidth },
          elementOffset = $element.offset(),
          inView = $element.data('inview');

      // Don't ask me why because I haven't figured out yet:
      // viewportOffset and viewportSize are sometimes suddenly null in Firefox 5.
      // Even though it sounds weird:
      // It seems that the execution of this function is interferred by the onresize/onscroll event
      // where viewportOffset and viewportSize are unset
      if (!viewportOffset || !viewportSize) {
        return;
      }

      if (elementOffset.top + elementSize.height > viewportOffset.top && elementOffset.top < viewportOffset.top + viewportSize.height && elementOffset.left + elementSize.width > viewportOffset.left && elementOffset.left < viewportOffset.left + viewportSize.width) {
        if (!inView) {
          $element.data('inview', true).trigger('inview', [true]);
        }
      } else if (inView) {
        $element.data('inview', false).trigger('inview', [false]);
      }
    }
  }

  $(w).on("scroll resize scrollstop", function () {
    viewportSize = viewportOffset = null;
  });

  // IE < 9 scrolls to focused elements without firing the "scroll" event
  if (!documentElement.addEventListener && documentElement.attachEvent) {
    documentElement.attachEvent("onfocusin", function () {
      viewportOffset = null;
    });
  }
});

/***/ }),

/***/ "EyDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preload", function() { return preload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setImagePadding", function() { return setImagePadding; });


/**
 *
 * Helper to preload images
 *
 * @param {object} $img - jquery image object to load as jquery selection
 * @param {function} callback - function to call after image loading
 * @return void
 */
var preload = function preload($img, callback) {
  var image_to_load, complete;

  // Create dummy image to ensure
  // proper reading of 'complete' property
  image_to_load = $('<img>');

  // Assign load handler
  image_to_load.one('load', function () {
    callback.apply(callback, [$img]);
    return true;
  });

  // Set src of dummy image
  image_to_load.attr('src', $img.attr('src'));

  // Get complete property
  complete = image_to_load[0].complete;

  if (complete === false) {
    return;
  }

  if (complete === true) {
    image_to_load.trigger('load');
    return;
  }

  image_to_load.trigger('load');
};

/**
 *
 * Sets padding on image wrapper depending on
 * current breakpoint. This is done to ensure that layout remains
 * unchanged as the image-src is dynamically inserted
 *
 * @param {object} $img - jquery selected image
 * @return void
 */
function setImagePadding($img, currentBreakPoint) {
  var dimensions = $img.data('dimensions'),
      paddingTop;

  if (dimensions && dimensions[currentBreakPoint]) {
    paddingTop = dimensions[currentBreakPoint];
  } else if (dimensions) {
    paddingTop = dimensions['large'];
  }

  if (paddingTop) {
    $img.parent('.js-imgparent').css('padding-top', paddingTop);
  }
}



/***/ }),

/***/ "HRs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JBd7":
/***/ (function(module, exports) {

$(function () {
  $('.js-fancy-img').fancybox({
    afterLoad: function afterLoad(instance, current) {
      var pixelRatio = window.devicePixelRatio || 1;

      if (pixelRatio > 1.5) {
        current.width = current.width / pixelRatio;
        current.height = current.height / pixelRatio;
      }
    }
  });
});

/***/ }),

/***/ "NeED":
/***/ (function(module, exports) {

/*
 *	@created: 14.01.2016, 12:07:25
 * 	@author: André Müller <entwickler@musteradresse.net>
 *
 */

//var $ = jQuery;

var iSwitchToMobile = 768;
var iMaxWidth = 960;
var iRemScaleFactor = 15;

var iStickyPosition = 100;

var tAnimationPause = 5600;
var tAnimationSpeed = 800;

(function( $ ) {
	var iWindowWidth = $(window).width();
	var iWindowHeight = $(window).height();

	$(window).resize(function(){
		iWindowWidth = $(window).width();
		iWindowHeight = $(window).height();
	});
})( jQuery );

/***/ }),

/***/ "XUtE":
/***/ (function(module, exports, __webpack_require__) {

var imgUtils = __webpack_require__("EyDu");
__webpack_require__("DyA4");

var mediaQuery = Foundation.MediaQuery;

/**
 *
 * Apply lazy image loading inview events
 * to images and bg images
 *
 * @param {object} $domScope - jquery element to use as root (optional)
 * @return void
 */
function initImages($domScope) {

  // Standard images and bg images
  var domScope = $domScope ? $domScope : $('body'),
      images,
      stdImages = $('img:not([data-lazyunveil]):not([data-interchange])', domScope);

  // Select all lazyloading elements, as well as
  // images and bg-images that use interchange, but not lazyload
  images = $('[data-lazyunveil], img[data-interchange], .js-lazyload-bgimg[data-interchange]');

  // Set image padding on mediaquery changed events
  $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
    var currentBreakPoint = mediaQuery.current;

    images.each(function (index, el) {
      imgUtils.setImagePadding($(el), currentBreakPoint);
    });
  }).trigger('changed.zf.mediaquery');

  // // Trigger resize for orbit sliders, otherwise
  // // orbit container size is off, as updated image paddings
  // // are not considered when foundation calculates height
  // // of orbit container
  // $('.js-orbit').trigger('resizeme.zf.trigger');

  // Normal/bg images with interchange values
  images.one('inview', function (event, visible) {
    event.stopPropagation();
    $(this).lazyInterchange();
  });

  // Normal images witout interchange
  stdImages.off('inview').one('inview', function (event, visible) {
    var img = $(this);

    event.stopPropagation();

    // Preload image before showing it
    imgUtils.preload(img, function () {
      img.addClass('img-loaded');
    });
  });

  // Trigger initial scroll if images are already in view
  window.setTimeout(function () {
    $(window).trigger('scroll');
  }, 550);
}

// function setImageWidths() {
//   return;
//   $('.imgwrap.js-addimgloaded').each(function(index, el) {
//     var $this = $(this),
//       currentWidth,
//       newWidth;

//     $this[0].style.width = '';

//     currentWidth = $this.width(),
//     newWidth = Math.ceil(currentWidth + 1);

//     $this.width(newWidth);
//   });
// }


(function () {
  var reflowTimer,
      elCache = $();

  // Interchange for standard images
  // used in conjunction with inview
  $.fn.lazyInterchange = function () {

    var selectors = this.each(function () {

      var $this = $(this);

      // Only set data-interchange if not already
      // present.
      if (!$this.attr('data-interchange')) {

        elCache = elCache.add($this);

        // prevents excessive loops interchange images in foundation.interchange.js
        if (reflowTimer) {
          clearRequestTimeout(reflowTimer);
        }

        reflowTimer = requestTimeout(function () {

          elCache.each(function (index, element) {
            var $el = $(element);

            new Foundation.Interchange($el, {
              rules: $el.attr('data-lazyunveil')
            });
          });

          elCache = $();
        }, 200);
      }
    });
    return selectors;
  };

  $(function () {

    // Trigger unveil on window resize
    $(window).on('resize', function (event) {
      var timer;

      window.clearTimeout(timer);

      timer = window.setTimeout(function () {
        $(window).trigger('scroll');
      }, 100);
    });

    // Replace callback for data-src images
    $(document).on('replaced.zf.interchange', 'img[data-lazyunveil]', function (e) {
      e.stopPropagation();

      var $img = $(e.currentTarget),
          $imgParent = $img.parents('.js-addimgloaded');

      // Preload image
      imgUtils.preload($img, function () {
        $imgParent.addClass('img-loaded');
        $img.addClass('img-loaded');
      });
    });

    // Replace callback for background images
    $(document).on('replaced.zf.interchange', '.js-lazyload-bgimg', function (e) {

      var $img, $this, bgImage;

      // Don't trigger event on fx parent ajax container
      e.stopPropagation();

      $img = $(e.currentTarget);

      $this = $(this);

      bgImage = $img[0].style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

      $img = $('<img>').attr('src', bgImage);

      // Preload image before showing it
      imgUtils.preload($img, function () {
        $this.removeClass('not-unveiled').addClass('img-loaded');
      });
    });

    initImages();

    $(window).trigger('resize');
  });
})();

/***/ }),

/***/ "YaKN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
* jQuery Cookie Plugin v1.4.0
* https://github.com/carhartl/jquery-cookie
*
* Copyright 2013 Klaus Hartl
* Released under the MIT license
*/
(function (factory) {
        if (true) {
                // AMD. Register as anonymous module.
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
                // Browser globals.
                factory(jQuery);
        }
}(function ($) {

        var pluses = /\+/g;

        function encode(s) {
                return config.raw ? s : encodeURIComponent(s);
        }

        function decode(s) {
                return config.raw ? s : decodeURIComponent(s);
        }

        function stringifyCookieValue(value) {
                return encode(config.json ? JSON.stringify(value) : String(value));
        }

        function parseCookieValue(s) {
                if (s.indexOf('"') === 0) {
                        // This is a quoted cookie as according to RFC2068, unescape...
                        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
                }

                try {
                        // Replace server-side written pluses with spaces.
                        // If we can't decode the cookie, ignore it, it's unusable.
                        // If we can't parse the cookie, ignore it, it's unusable.
                        s = decodeURIComponent(s.replace(pluses, ' '));
                        return config.json ? JSON.parse(s) : s;
                } catch(e) {}
        }

        function read(s, converter) {
                var value = config.raw ? s : parseCookieValue(s);
                return $.isFunction(converter) ? converter(value) : value;
        }

        var config = $.cookie = function (key, value, options) {

                // Write
                if (value !== undefined && !$.isFunction(value)) {
                        options = $.extend({}, config.defaults, options);

                        if (typeof options.expires === 'number') {
                                var days = options.expires, t = options.expires = new Date();
                                t.setDate(t.getDate() + days);
                        }

                        return (document.cookie = [
                                encode(key), '=', stringifyCookieValue(value),
                                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                                options.path ? '; path=' + options.path : '',
                                options.domain ? '; domain=' + options.domain : '',
                                options.secure ? '; secure' : ''
                        ].join(''));
                }

                // Read

                var result = key ? undefined : {};

                // To prevent the for loop in the first place assign an empty array
                // in case there are no cookies at all. Also prevents odd result when
                // calling $.cookie().
                var cookies = document.cookie ? document.cookie.split('; ') : [];

                for (var i = 0, l = cookies.length; i < l; i++) {
                        var parts = cookies[i].split('=');
                        var name = decode(parts.shift());
                        var cookie = parts.join('=');

                        if (key && key === name) {
                                // If second argument (value) is a function it's a converter...
                                result = read(cookie, value);
                                break;
                        }

                        // Prevent storing a cookie that we couldn't decode.
                        if (!key && (cookie = read(cookie)) !== undefined) {
                                result[name] = cookie;
                        }
                }

                return result;
        };

        config.defaults = {};

        $.removeCookie = function (key, options) {
                if ($.cookie(key) === undefined) {
                        return false;
                }

                // Must not alter options, thus extending a fresh object...
                $.cookie(key, '', $.extend({}, options, { expires: -1 }));
                return !$.cookie(key);
        };

}));


/***/ }),

/***/ "c8nw":
/***/ (function(module, exports) {

/*
 *	@created: 05.04.2017, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 *
 */

(function ($) {
	$(document).ready(function () {
		setContrastCookie();
	});

	function setContrastCookie() {
		//console.log($.cookie('t3zcontrast'));
		if ($.cookie('t3zcontrast') == 'true') {
			$('#contrastview').prop('checked', true);
		}
		$('label[for="contrastview"]').click(function (event) {
			if ($.cookie('t3zcontrast') == 'true') {
				$.cookie('t3zcontrast', 'false', {expires: 1, path: '/'});
			} else {
				$.cookie('t3zcontrast', 'true', {expires: 1, path: '/'});
			}
			//console.log($.cookie('t3zcontrast'));
		});
	}
})(jQuery);


/***/ }),

/***/ "cbRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/js/modules/foundation-config.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_foundation_sites_js_entries_plugins_foundation_core__ = __webpack_require__("58At");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_foundation_sites_js_entries_plugins_foundation_util_triggers__ = __webpack_require__("CHsG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_foundation_sites_js_entries_plugins_foundation_util_mediaQuery__ = __webpack_require__("C5ZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_foundation_sites_js_entries_plugins_foundation_util_keyboard__ = __webpack_require__("hoSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_foundation_sites_js_entries_plugins_foundation_util_imageloader__ = __webpack_require__("zlij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_foundation_sites_js_entries_plugins_foundation_interchange__ = __webpack_require__("eNte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_foundation_sites_js_entries_plugins_foundation_offcanvas__ = __webpack_require__("pSYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_foundation_sites_js_entries_plugins_foundation_drilldown__ = __webpack_require__("O8Qv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_foundation_sites_js_entries_plugins_foundation_tabs__ = __webpack_require__("u1Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_foundation_sites_js_entries_plugins_foundation_accordion__ = __webpack_require__("fNz6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_foundation_sites_js_entries_plugins_foundation_equalizer__ = __webpack_require__("Og6R");












Foundation.Interchange.SPECIAL_QUERIES['retinaDefault'] = ['only screen and (-webkit-min-device-pixel-ratio: 2)', 'only screen and (min--moz-device-pixel-ratio: 2)', 'only screen and (-o-min-device-pixel-ratio: 2/1)', 'only screen and (min-device-pixel-ratio: 2)', 'only screen and (min-resolution: 192dpi)', 'only screen and (min-resolution: 2dppx)'].join(', ');

Foundation.Interchange.SPECIAL_QUERIES['retinaSmall'] = ['only screen and (min-width: 0em) and (-webkit-min-device-pixel-ratio: 2)', 'only screen and (min-width: 0em) and (min--moz-device-pixel-ratio: 2)', 'only screen and (min-width: 0em) and (-o-min-device-pixel-ratio: 2/1)', 'only screen and (min-width: 0em) and (min-device-pixel-ratio: 2)', 'only screen and (min-width: 0em) and (min-resolution: 192dpi)', 'only screen and (min-width: 0em) and (min-resolution: 2dppx)'].join(', ');

Foundation.Interchange.SPECIAL_QUERIES['retinaMedium'] = ['only screen and (min-width: 40.0625em) and (-webkit-min-device-pixel-ratio: 2)', 'only screen and (min-width: 40.0625em) and (min--moz-device-pixel-ratio: 2)', 'only screen and (min-width: 40.0625em) and (-o-min-device-pixel-ratio: 2/1)', 'only screen and (min-width: 40.0625em) and (min-device-pixel-ratio: 2)', 'only screen and (min-width: 40.0625em) and (min-resolution: 192dpi)', 'only screen and (min-width: 40.0625em) and (min-resolution: 2dppx)'].join(', ');

Foundation.Interchange.SPECIAL_QUERIES['retinaLarge'] = ['only screen and (min-width: 68.75em) and (-webkit-min-device-pixel-ratio: 2)', 'only screen and (min-width: 68.75em) and (min--moz-device-pixel-ratio: 2)', 'only screen and (min-width: 68.75em) and (-o-min-device-pixel-ratio: 2/1)', 'only screen and (min-width: 68.75em) and (min-device-pixel-ratio: 2)', 'only screen and (min-width: 68.75em) and (min-resolution: 192dpi)', 'only screen and (min-width: 68.75em) and (min-resolution: 2dppx)'].join(', ');

$(document).foundation();
// CONCATENATED MODULE: ./src/js/modules/counter.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_countup_js__ = __webpack_require__("EbL4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_countup_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_countup_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_inview__ = __webpack_require__("DyA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_inview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__plugins_inview__);



$(function () {

  $('.js-counter').each(function (index, el) {

    var data = $(el).data(),
        duration = data.duration,
        options = void 0,
        counter = void 0,
        shouldUpdate = void 0;

    // Consider value being in milliseconds
    if (duration > 1000) {
      duration /= 1000;
    }

    // Default duration
    if (!duration) {
      duration = 3.5;
    }

    options = {
      useEasing: true,
      useGrouping: data.grouping === 1 ? true : false,
      decimal: data.decimalSeparator === 0 ? ',' : '.',
      separator: data.groupingSeparator === 0 ? '.' : ','

      // see https://github.com/inorganik/CountUp.js#animating-to-large-numbers
    };if (data.to > 5000) {
      shouldUpdate = true;
      counter = new __WEBPACK_IMPORTED_MODULE_0_countup_js___default.a(el, data.from, data.to - 100, data.decimalsCount, duration / 2, options);
    } else {
      counter = new __WEBPACK_IMPORTED_MODULE_0_countup_js___default.a(el, data.from, data.to, data.decimalsCount, duration, options);
    }

    if (!counter.error) {

      // When in view start counter
      $(this).one('inview', function (event, visible) {
        event.stopPropagation();

        counter.start(function () {
          if (shouldUpdate) {
            counter.update(data.to);
          }
        });
      });
    }
  });
});
// CONCATENATED MODULE: ./src/js/modules/progress-bars.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_progressbar_js__ = __webpack_require__("xwJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_progressbar_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_progressbar_js__);


function setPercentageProgress(state, bar, opt) {
  return Math.round(bar.value() * 100) + ' ' + opt.unit;
}

function setActualProgress(state, bar, opt) {
  return Math.round(bar.value() * opt.maxValue) + ' ' + opt.unit;
}

$(function () {
  var _this = this;

  $('.js-progress-bar').each(function (index, el) {

    var data = $(el).data(),
        updateCallback = void 0,
        mergedOptions = {},
        defaultOptions = {
      unit: '%',
      duration: 1400,
      color: '#333333'
    },
        bar = void 0;

    for (var x in data) {
      if (data && data.hasOwnProperty(x) && data[x]) {
        mergedOptions[x] = data[x];
      } else {
        mergedOptions[x] = defaultOptions[x];
      }
    }

    if (mergedOptions.unit === '%') {
      updateCallback = setPercentageProgress;
    } else {
      updateCallback = setActualProgress;
    }

    bar = new __WEBPACK_IMPORTED_MODULE_0_progressbar_js___default.a.Line(el, {
      strokeWidth: 4,
      easing: 'easeInOut',
      duration: mergedOptions.duration,
      color: mergedOptions.color,
      trailColor: 'transparent',
      trailWidth: 1,
      svgStyle: { width: '100%', height: '100%' },
      text: {
        style: {
          // Text color.
          // Default: same as stroke color (options.color)
          color: 'inherit'
        },
        autoStyleContainer: false
      },
      from: { color: '#FFEA82' },
      to: { color: '#ED6A5A' },
      step: function step(state, bar) {
        var value = updateCallback.apply(_this, [state, bar, mergedOptions]);
        bar.setText(value);
        bar.text.style.left = bar.value() * 100 + '%';
      }
    });

    if (mergedOptions.minValue) {
      bar.set(data.minValue / data.maxValue);
    }

    $(el).one('inview', function (event, visible) {
      event.stopPropagation();
      bar.animate(data.targetValue / data.maxValue);
    });
  });
});
// CONCATENATED MODULE: ./src/js/modules/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_requestAnimFrame__ = __webpack_require__("6KHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_requestAnimFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plugins_requestAnimFrame__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_requestInterval__ = __webpack_require__("e8Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_requestInterval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__plugins_requestInterval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_requestTimeout__ = __webpack_require__("i7+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_requestTimeout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plugins_requestTimeout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sliders__ = __webpack_require__("nkBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sliders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sliders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images__ = __webpack_require__("XUtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fancybox__ = __webpack_require__("JBd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fancybox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fancybox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dial__ = __webpack_require__("peV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__font_switcher__ = __webpack_require__("q/t+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__font_switcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__font_switcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__maps__ = __webpack_require__("hIZ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tabs__ = __webpack_require__("wE9B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__tabs__);














// CONCATENATED MODULE: ./src/js/app.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__ = __webpack_require__("ZR5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel__ = __webpack_require__("gqkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Var_js__ = __webpack_require__("NeED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Var_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Var_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__t3zeroseven_Resources_Public_Scripts_jQueryPlugins_jquery_cookie_js__ = __webpack_require__("YaKN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__t3zeroseven_Resources_Public_Scripts_jQueryPlugins_jquery_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__t3zeroseven_Resources_Public_Scripts_jQueryPlugins_jquery_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__t3zeroseven_Resources_Public_Scripts_T3Zero_setContrastCookie_js__ = __webpack_require__("c8nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__t3zeroseven_Resources_Public_Scripts_T3Zero_setContrastCookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__t3zeroseven_Resources_Public_Scripts_T3Zero_setContrastCookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Functions_js__ = __webpack_require__("6N6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Functions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__t3zeroseven_Resources_Public_Sites_Zero_Scripts_Functions_js__);



//import 'jquery';



// Add needed scripts from t3zeroseven extension,
// we override the font-switcher in Modules folder





/***/ }),

/***/ "e8Kh":
/***/ (function(module, exports) {

/**
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */
window.requestInterval = function (fn, delay) {
  if (!window.requestAnimationFrame) return window.setInterval(fn, delay);

  var start = new Date().getTime(),
      handle = new Object();

  function loop() {
    var current = new Date().getTime(),
        delta = current - start;

    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }

    handle.value = requestAnimFrame(loop);
  };

  handle.value = requestAnimFrame(loop);
  return handle;
};

/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
window.clearRequestInterval = function (handle) {
  window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) : clearInterval(handle);
};

/***/ }),

/***/ "hIZ+":
/***/ (function(module, exports) {



$(function () {

  $('.js-map-fullscreen').on('click', function () {
    $(this).parent('.js-multimaps-map').toggleClass('fullscreen');
    $(window).trigger('resize');
  });
});

/***/ }),

/***/ "i7+m":
/***/ (function(module, exports) {

/**
 * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */

window.requestTimeout = function (fn, delay) {
  if (!window.requestAnimationFrame) return window.setTimeout(fn, delay);

  var start = new Date().getTime(),
      handle = new Object();

  function loop() {
    var current = new Date().getTime(),
        delta = current - start;

    delta >= delay ? fn.call() : handle.value = requestAnimFrame(loop);
  };

  handle.value = requestAnimFrame(loop);
  return handle;
};

/**
 * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
window.clearRequestTimeout = function (handle) {
  window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) : clearTimeout(handle);
};

/***/ }),

/***/ "nkBR":
/***/ (function(module, exports) {

$(function () {
  var sliders = $('.js-slider'),
      $window = $(window);

  sliders.each(function (index, element) {
    var $el = $(element);

    if ($el.is('.js-content-slider')) {
      $el.slick({
        lazyLoad: false,
        responsive: [{
          breakpoint: 640,
          settings: {
            dots: true,
            arrows: false
          }
        }]
      });
    } else {
      $el.slick({
        lazyLoad: false
      });
    }
  });

  sliders.on('afterChange', function (event, slick, currentSlide) {

    // Ensure lazy loading images are loaded
    $window.trigger('scroll');
  });
});

/***/ }),

/***/ "peV5":
/***/ (function(module, exports) {



$(function () {
  $('.js-dial-container').each(function (index, el) {

    var parent = $(el);

    parent.find('.js-dial-item').on('mouseenter', function () {
      parent.attr('data-active', $(this).index());
    });
  });
});

/***/ }),

/***/ "q/t+":
/***/ (function(module, exports) {


/*
 * -------------------------------
 *  Creation origin: t3zeroseven extension
 *	@created: 05.04.2017, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 * -------------------------------
 *
 * We override the font switcher
 * to enable rem based scaling on html tag
 * for correct resizing of foundation rem based sizes
 */

var fFontSizeBase = parseFloat(1.0);
var fFontSizeMin = parseFloat(0.9);
var fFontSizeMax = parseFloat(1.9);

function fontSizeSwitcher() {

  fFontSizeCurrent = parseFloat($('#canvas').attr('data-fontsize'));
  if ($.cookie('t3zfontsizer')) {
    fFontSizeCurrent = parseFloat($.cookie('t3zfontsizer'));
  }
  //console.log(fFontSizeCurrent);
  setFontSize(fFontSizeCurrent);

  $('#fontsize-minus').click(function (event) {
    event.preventDefault();
    if (fFontSizeCurrent.toFixed(1) > fFontSizeMin.toFixed(1)) {
      fFontSizeCurrent = fFontSizeCurrent - parseFloat(0.1);
    }
    setFontSize(fFontSizeCurrent);
  });

  $('#fontsize-base').click(function (event) {
    event.preventDefault();
    fFontSizeCurrent = fFontSizeBase;
    setFontSize(fFontSizeCurrent);
  });

  $('#fontsize-plus').click(function (event) {
    event.preventDefault();
    if (fFontSizeCurrent.toFixed(1) < fFontSizeMax.toFixed(1)) {
      fFontSizeCurrent = fFontSizeCurrent + parseFloat(0.1);
    }
    setFontSize(fFontSizeCurrent);
  });
}

function setFontSize(fSetFontSize) {
  //console.log(fSetFontSize);
  $.cookie('t3zfontsizer', fSetFontSize, { expires: 1, path: '/' });
  var sSetFontSize = String(fSetFontSize.toFixed(1));
  //console.log(sSetFontSize);
  $('html').attr('data-fontsize', sSetFontSize);
  $('html').css('font-size', sSetFontSize + 'rem');

  $('label.fontsize').removeClass('disabled');

  if (fFontSizeCurrent.toFixed(1) == fFontSizeBase.toFixed(1)) {
    $('#fontsize-base').addClass('disabled');
  }
  if (fFontSizeCurrent.toFixed(1) == fFontSizeMin.toFixed(1)) {
    $('#fontsize-minus').addClass('disabled');
  }
  if (fFontSizeCurrent.toFixed(1) == fFontSizeMax.toFixed(1)) {
    $('#fontsize-plus').addClass('disabled');
  }

  // Update slick slider sizes
  $('.js-slider').slick('setPosition');
}

$(function () {
  fontSizeSwitcher();
});

/***/ }),

/***/ "wE9B":
/***/ (function(module, exports) {

$(function () {

  // Detect hashchange events, to fix timing issue
  // where foundation tabs does not always scroll to content, when
  // changing hash via link on the same page
  $(window).on('hashchange', function (e) {
    var hash = window.location.hash,
        hashtarget = void 0;

    // Close map overlay if it is open
    if ($('.multimaps-map.fullscreen').length) {
      $('.js-map-fullscreen').trigger('click');
    }

    if (hash) {

      // Add small delay and force scroll to hash target
      window.setTimeout(function () {
        hashtarget = $(hash);
        if (hashtarget.length) {
          $(window).scrollTop(hashtarget.offset().top);
        }
      }, 30);
    }
  });
});

/***/ })

},[1]);


// WEBPACK FOOTER //
// js/app/app.bundle.js